import "./Privacy.css";

function Privacy() {
  return <h2>Privacy</h2>;
}

export default Privacy;
